const config = require('../../../../../config/locales_json/packs/private/validations/recover_password.json');
const language = $('body').data("language");

/**************************************************
 * 
 *    V A L I D A C I O N E S    U S U A R I O
 * 
*/
$("#kt_login_forgot_form #kt_login_forgot_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_forgot_form #user_email")

  if(!email.val()){
    const errorText = getTranslationValue(config, [language, "user_email"],"Debes ingresar el email con el cual te registraste.");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Enviando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_forgot_form").submit()
  }
});

/**************************************************
 * 
 *  V A L I D A C I O N E S    R E C L U T A D O R
 * 
*/
$("#kt_login_recruiter_forgot_form #kt_login_recruiter_forgot_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_recruiter_forgot_form #recruiter_email")

  if(!email.val()){
    const errorText = getTranslationValue(config, [language, "recruiter_email"],"Debe ingresar el email con el cual esta registrado en la plataforma.");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.removeClass("is-invalid")
  }

  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Enviando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_recruiter_forgot_form").submit()
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}